(function () {
  'use strict';

  document.documentElement.classList.add('k4-js');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  if (!customElements.get('ka-ke4-gallery')) {
    customElements.define('ka-ke4-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.buttons = Array.from(this.querySelectorAll('[data-k4-thumb]'));
        this.slides = Array.from(this.querySelectorAll('[data-k4-slide]'));
        this.buttons.forEach((button) => {
          button.addEventListener('click', () => this.show(button.dataset.mediaId, button));
        });
      }

      show(mediaId, activeButton) {
        this.buttons.forEach((button) => {
          button.setAttribute('aria-current', button === activeButton ? 'true' : 'false');
        });

        this.slides.forEach((slide) => {
          var isActive = slide.dataset.mediaId === mediaId;
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          slide.toggleAttribute('inert', !isActive);
          if (!isActive) {
            slide.querySelectorAll('video').forEach((video) => video.pause());
          }
        });

        var activeSlide = this.slides.find((slide) => slide.dataset.mediaId === mediaId);
        var activeVideo = activeSlide && activeSlide.querySelector('video');
        if (activeVideo && activeVideo.hasAttribute('autoplay') && !reduceMotion.matches) {
          activeVideo.play().catch(function () {});
        }
      }
    });
  }

  function reveal(root) {
    var elements = Array.from(root.querySelectorAll('.k4-reveal:not([data-k4-reveal-ready])'));
    if (!elements.length) return;
    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      elements.forEach((element) => element.classList.add('k4-in'));
      return;
    }

    var observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('k4-in');
        observer.unobserve(entry.target);
      });
    }, { threshold: .08, rootMargin: '0px 0px -60px 0px' });

    elements.forEach((element) => {
      element.dataset.k4RevealReady = 'true';
      observer.observe(element);
    });
  }

  var bloomItems = new Set();
  var bloomFrame = null;

  function paintBloom() {
    bloomFrame = null;
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    bloomItems.forEach((element) => {
      if (!element.isConnected) {
        bloomItems.delete(element);
        return;
      }
      var rect = element.getBoundingClientRect();
      if (rect.bottom < -200 || rect.top > viewportHeight + 200) return;
      var middle = rect.top + rect.height / 2;
      var raw = (viewportHeight - middle) / (viewportHeight * .7);
      var progress = Math.max(0, Math.min(1, raw));
      var eased = 1 - Math.pow(1 - progress, 3);
      element.style.setProperty('--k4-progress', eased.toFixed(4));
    });
  }

  function requestBloom() {
    if (bloomFrame || reduceMotion.matches) return;
    bloomFrame = window.requestAnimationFrame(paintBloom);
  }

  function bloom(root) {
    root.querySelectorAll('.k4-bloom').forEach((element) => bloomItems.add(element));
    if (reduceMotion.matches) {
      bloomItems.forEach((element) => element.style.setProperty('--k4-progress', '1'));
    } else {
      requestBloom();
    }
  }

  function initialize(root) {
    reveal(root);
    bloom(root);
  }

  initialize(document);
  window.addEventListener('scroll', requestBloom, { passive: true });
  window.addEventListener('resize', requestBloom, { passive: true });
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
